import { Injectable } from '@angular/core';
import { DashboardDateRangeFilter } from './dashboard-filter-type.enum';
import { utils } from '@bayclubs/utils'
import { TimeService } from '@bayclubs/utils';
import moment from 'moment';


@Injectable()
export class DashboardFilterService {
    constructor(private time: TimeService) { }

    public getFilterResult(filterType: DashboardDateRangeFilter): DashboardFilterResult {
        if (filterType === DashboardDateRangeFilter.Last30Days) {

            const today = this.time.endOfDay(this.time.nowInTimeZone(this.time.defaultTimezone()));
            return new DashboardFilterResult(this.time.startOfDay(this.time.addDays(today, -30)), today)
        }
        if (filterType === DashboardDateRangeFilter.CurrentMonth) {

            const today = this.time.nowInTimeZone(this.time.defaultTimezone());
            return new DashboardFilterResult(this.time.startOfMonth(today), this.time.endOfMonth(today))
        }
        if (filterType === DashboardDateRangeFilter.LastMonth) {

            const today = this.time.nowInTimeZone(this.time.defaultTimezone());
            const monthEarlier = this.time.addMonths(today, -1);
            return new DashboardFilterResult(this.time.startOfMonth(monthEarlier), this.time.endOfMonth(monthEarlier))
        }
        if (filterType === DashboardDateRangeFilter.CurrentYear) {

            const today = this.time.nowInTimeZone(this.time.defaultTimezone());
            return new DashboardFilterResult(this.time.startOfYear(today), this.time.endOfYear(today))
        }
        if (filterType === DashboardDateRangeFilter.LastYear) {

            const today = this.time.nowInTimeZone(this.time.defaultTimezone());
            const yearEarlier = this.time.addYears(today, -1);
            return new DashboardFilterResult(this.time.startOfYear(yearEarlier), this.time.endOfYear(yearEarlier))
        }


        return new DashboardFilterResult(null, null);
    }
}

export class DashboardFilterResult {
    constructor(public dateFrom: moment.Moment, public dateTo: moment.Moment) {

    }
}
